import { apiClient } from './api-client';
import {
  CreateSessionResponse,
  SendMessageResponse,
  ListSessionsResponse,
  GetMessagesResponse,
} from '@recruitai/shared';

export async function createAssistantSession(): Promise<CreateSessionResponse> {
  return apiClient.post<CreateSessionResponse>('/assistant/sessions', {});
}

export async function sendAssistantMessage(
  sessionId: string,
  content: string
): Promise<SendMessageResponse> {
  return apiClient.post<SendMessageResponse>(
    `/assistant/sessions/${sessionId}/messages`,
    { content }
  );
}

export async function getAssistantMessages(sessionId: string): Promise<GetMessagesResponse> {
  return apiClient.get<GetMessagesResponse>(`/assistant/sessions/${sessionId}/messages`);
}

export async function listAssistantSessions(): Promise<ListSessionsResponse> {
  return apiClient.get<ListSessionsResponse>('/assistant/sessions');
}
